import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MVIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MV" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0h16v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#579D20"
        fillRule="evenodd"
        d="M2.4 2.4h11.2v7.2H2.4V2.4Z"
        clipRule="evenodd"
      />
      <Path
        stroke="#B6EB9A"
        strokeOpacity={0.238}
        d="M13.1 2.9v6.2H2.9V2.9h10.2Z"
      />
      <Mask
        id="b"
        width={12}
        height={8}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M2.4 2.4h11.2v7.2H2.4V2.4Z"
          clipRule="evenodd"
        />
        <Path stroke="#fff" d="M13.1 2.9v6.2H2.9V2.9h10.2Z" />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F9FAFA"
          fillRule="evenodd"
          d="M8.016 6.231c-.008 1.533 1.199 2.35 1.199 2.35-1.377.162-2.293-1.086-2.293-2.335 0-1.248 1.248-2.28 2.293-2.746 0 0-1.19 1.198-1.199 2.731Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
